let optimisticId = -1;
export default function generateOptimisticId() {
    return optimisticId--;
};
